module.exports = __webpack_public_path__ + "static/media/umpire-mask.87ae94e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/umpire-mask.png
// module id = 245
// module chunks = 0